import { FundriseRouteConfig } from 'vue-router';
import { getWebsiteDocument } from '@api/website-document';
import { makettoDocumentRedirects } from '@constants';

const documentRedirectRoutes: Array<FundriseRouteConfig> = [
	{
		path: '/website-documents/:title',
		name: 'website-document-view',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		beforeEnter: async (to, from, next) => {
			const title = to.params.title;
			try {
				const redirectLink = await getWebsiteDocument(title);
				window.location.href = redirectLink.redirectUrl;
			} catch {
				next({ name: '404', replace: true });
			}
		}
	},
	{
		path: '/offerings/:offeringId/documents/:documentName',
		name: 'maketto-offering-document-redirect',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		beforeEnter: async (to, from, next) => {
			const { offeringId, documentName } = to.params;
			const filePath = makettoDocumentRedirects.get(documentName);

			if (offeringId === '1' && filePath) {
				window.location.href = `${process.env.VUE_APP_CLOUDFRONT_DOMAIN}/offering-documents/${filePath}`;
			} else {
				next({ name: '404', replace: true });
			}
		}
	}
];

export default documentRedirectRoutes;
